import { gsap } from "gsap";
import { SplitText, DrawSVGPlugin } from "gsap/all";

const heroBlock = () => {
	// Detect reduced motion preference
	const prefersReducedMotion = window.matchMedia(
		"(prefers-reduced-motion: reduce)"
	).matches;

	if (prefersReducedMotion) return;

	gsap.registerPlugin(SplitText, DrawSVGPlugin);
	const timeline = gsap.timeline();

	// Select the title element
	const title = document.querySelector(".hero-block__title-container h1");

	// Split the text using SplitText
	const splitTitle = new SplitText(title, { type: "chars" });

	// Animate each title letter
	timeline.fromTo(
		splitTitle.chars, // Array of split characters
		{ y: 50, opacity: 0 },
		{
			y: 0,
			opacity: 1,
			duration: 1.2,
			ease: "back.out(1.7)", // Bounce effect
			stagger: 0.05, // Stagger between letters
			onComplete: () => {
				// Revert to the original text after animation
				splitTitle.revert();
			},
		}
	);

	// Subtitle animation (fade in and rise)
	timeline.fromTo(
		".hero-block__subtitle-container h2",
		{ opacity: 0 },
		{
			opacity: 1,
			y: 0,
			ease: "power2.out", // Smooth easing
		},
		"-=0.4" // Overlap with the middle of the line drawing
	);

	// Line under the subtitle
	timeline.fromTo(
		".hero-block__subtitle-container svg path",
		{ drawSVG: "0%" }, // Start with the line not drawn
		{
			drawSVG: "100%", // Fully draw the line
			duration: 0.5, // Match the subtitle's fade duration
			ease: "power2.out", // Smooth easing
		},
		"-=0.4" // Match the exact start of the subtitle fade-in
	);

	// Shapes animation (scale and fade in with stagger)
	timeline.fromTo(
		".hero-block__graphic--hourglass, .hero-block__graphic--arc, .hero-block__graphic--hex, .hero-block__graphic--stairs",
		{ scale: 0.5, opacity: 0 },
		{
			scale: 1,
			opacity: 1,
			duration: 0.8,
			ease: "back.out(1.5)", // Smooth pop-in effect
			stagger: 0.2, // Sequential entry
		},
		"-=0.6" // Overlap more with the subtitle animation
	);
};

export default heroBlock;
